module.exports = __webpack_public_path__ + "img/18.b4f91d43.jpg";